import GerepAPI from './GerepAPI'

export default class SanteClairService {

	static getToken(token) {
		return GerepAPI.get('/services/santeclair/token', null, token)
	}
}
